import EmptyRouterParent from '@/pmd/pages/EmptyRouterParent.vue'
import { Modules } from '../../util/modules'
import { RouteConfig } from 'vue-router'
import { marketingRouteNames } from '@/routes/constants/location'
import { requireAuthAndLocation } from '../auth'

const TriggerLinks = () => import(/* webpackChunkName: "trigger-links" */ '@/apps/trigger-links/LinksRouter.vue')
const TriggerLinksOld = () => import(/* webpackChunkName: "trigger-links" */ '@/pmd/pages/links/TriggerLinks.vue')
const SocialMediaPostDashboard = () => import('@/pmd/pages/socialPlanner/InitialisedPlanner.vue')
const Emails = () => import('@/pmd/pages/emailBuilder/EmailsComp.vue')
const AffiliateManagerDashboard = () =>
  import(/* webpackChunkName: "affiliate-manager" */ '@/pmd/pages/AffiliateManager.vue')
const AdManager = () =>
  import(/* webpackChunkName: "ad-manager-home" */ '@/pmd/pages/ad_manager/AdManager.vue').then(m => m.default)

const AdManagerSettings = () =>
  import(/* webpackChunkName: "ad-manager-settings" */ '@/pmd/pages/ad_manager/AdSettings.vue').then(m => m.default)

const AdManagerCampaignBuilder = () =>
  import(/* webpackChunkName: "ad-manager-campaign-builder" */ '@/pmd/pages/ad_manager/Campaign.vue').then(
    m => m.default
  )

const AdManagerCampaignStatistics = () =>
  import(/* webpackChunkName: "ad-manager-campaign-statistics" */ '@/pmd/pages/ad_manager/CampaignStatistics.vue').then(
    m => m.default
  )

const CountdownTimerList = () =>
  import(/* webpackChunkName: "countdown-timer" */ '@/pmd/pages/countdown_timer/CountdownTimerList.vue')
const LinksPage = () => import(/* webpackChunkName: "m-links" */ '@/pmd/pages/marketing/LinksPage.vue')

const Snippets = () => import(/* webpackChunkName: "snippets" */ '@/pmd/pages/snippets/Snippets.vue')

const BrandBoardsBuilder = () => import('@/pmd/pages/brand_boards/Builder.vue').then(m => m.default)

const BrandBoardsList = () => import('@/pmd/pages/brand_boards/List.vue').then(m => m.default)

const BrandVoiceBuilder = () => import('@/pmd/pages/brand_boards/VoiceBuilder.vue').then(m => m.default)

const ProspectingLocationParent = () =>
  import(/* webpackChunkName: "prospecting" */ '@/pmd/pages/prospecting/ProspectingLocationParent.vue').then(
    m => m.default
  )

export const marketingRoute: RouteConfig[] = [
  {
    path: 'marketing',
    name: 'marketing-v2',
    component: EmptyRouterParent,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: 'social-planner',
        component: EmptyRouterParent,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: '',
            name: 'social-planner-dashboard-v2',
            component: SocialMediaPostDashboard,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'list',
            name: 'social-planner-list-v2',
            component: SocialMediaPostDashboard,
            beforeEnter: requireAuthAndLocation,
            meta: {
              hideTopBar: false,
            },
          },
          {
            path: 'post',
            name: 'social-planner-post-v2',
            component: SocialMediaPostDashboard,
            beforeEnter: requireAuthAndLocation,
            meta: {
              hideTopBar: true,
            },
          },
          {
            path: 'post/:id',
            name: 'social-planner-post-edit-v2',
            component: SocialMediaPostDashboard,
            beforeEnter: requireAuthAndLocation,
            meta: {
              hideTopBar: true,
            },
          },
          {
            path: 'content',
            name: 'social-planner-content',
            component: SocialMediaPostDashboard,
            beforeEnter: requireAuthAndLocation,
            meta: {
              hideTopBar: false,
            },
          },
          {
            path: 'planner',
            name: 'social-planner-planner',
            component: SocialMediaPostDashboard,
            beforeEnter: requireAuthAndLocation,
            meta: {
              hideTopBar: false,
            },
          },
          {
            path: 'review-post',
            name: 'social-planner-create-review-post',
            component: SocialMediaPostDashboard,
            beforeEnter: requireAuthAndLocation,
            meta: {
              hideTopBar: true,
            },
          },
          {
            path: 'review-post/:id',
            name: 'social-planner-review-post-edit',
            component: SocialMediaPostDashboard,
            beforeEnter: requireAuthAndLocation,
            meta: {
              hideTopBar: true,
            },
          },
          {
            path: 'category-queue/:id',
            name: marketingRouteNames.socialPlanner.categoryQueue,
            component: SocialMediaPostDashboard,
            beforeEnter: requireAuthAndLocation,
            meta: {
              hideTopBar: true,
            },
          },
          {
            path: 'csv',
            name: marketingRouteNames.socialPlanner.csvCreate,
            component: SocialMediaPostDashboard,
            beforeEnter: requireAuthAndLocation,
            meta: {
              hideTopBar: true,
            },
          },
          {
            path: 'csv/:id',
            name: marketingRouteNames.socialPlanner.csvEdit,
            component: SocialMediaPostDashboard,
            beforeEnter: requireAuthAndLocation,
            meta: {
              hideTopBar: true,
            },
          },
          {
            path: 'settings',
            name: 'social-planner-settings-v2',
            component: SocialMediaPostDashboard,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'statistics',
            name: 'social-planner-statistics',
            component: SocialMediaPostDashboard,
            beforeEnter: requireAuthAndLocation,
            meta: {
              hideTopBar: false,
            },
          },
          {
            path: 'comments',
            name: 'social-planner-comments',
            component: SocialMediaPostDashboard,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'social-listening',
            name: marketingRouteNames.socialPlanner.socialListening,
            component: SocialMediaPostDashboard,
            beforeEnter: requireAuthAndLocation,
            meta: {
              hideTopBar: false,
            },
          },
        ],
      },
      {
        path: 'emails',
        name: 'emails_home-v2',
        component: Emails,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'all',
            name: 'emails_home-v2-templates',
            component: Emails,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'scheduled',
            name: 'emails_home-v2-campaigns',
            component: Emails,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'statistics',
            name: 'emails_home-v2-statistics',
            component: Emails,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'settings',
            name: 'emails_home-v2-settings',
            component: Emails,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: ':source/:sourceId/statistics',
            name: 'emails_home-v2-campaign-statistics',
            component: Emails,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'emails/:path',
        name: 'emails_home-v2_detail',
        component: Emails,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'emails/detail/:path',
        name: 'emails_home-details-v2',
        component: Emails,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'brand-boards/voice/builder/:brandVoiceId',
        name: marketingRouteNames.brandBoard.voiceBuilder,
        component: BrandVoiceBuilder,
        beforeEnter: requireAuthAndLocation,
        meta: {
          hideTopBar: true,
          hideSideBar: true,
        },
      },
      {
        path: 'brand-boards/builder/:brandBoardId',
        name: marketingRouteNames.brandBoard.builder,
        component: BrandBoardsBuilder,
        beforeEnter: requireAuthAndLocation,
        meta: {
          hideTopBar: true,
          hideSideBar: true,
        },
      },
      {
        path: 'brand-boards',
        name: marketingRouteNames.brandBoard.default,
        component: BrandBoardsList,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'prospecting',
        name: marketingRouteNames.prospecting.default,
        component: ProspectingLocationParent,
        beforeEnter: requireAuthAndLocation,
        meta: {
          hideTopBar: false,
          translations: [Modules.Prospecting],
        },
        children: [
          {
            path: ':pathMatch(.*)*',
            name: 'location_prospect_any',
            component: ProspectingLocationParent,
            beforeEnter: requireAuthAndLocation,
          },
        ],
      },
      {
        path: 'templates',
        name: 'templates-v2',
        component: Snippets,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'countdown-timer',
        name: 'countdown-timer-list-v2',
        component: CountdownTimerList,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'trigger-links',
        name: 'triggers-links-marketing-v3',
        component: TriggerLinks,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'links',
        name: 'triggers-links-v2',
        component: EmptyRouterParent,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'link',
            name: 'triggers-links-link-v2',
            component: TriggerLinksOld,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'analyze',
            name: 'triggers-links-analyze-v2',
            component: LinksPage,
            beforeEnter: requireAuthAndLocation,
            meta: { translations: [Modules.TriggerLinkAnalyze, Modules.SmartList] },
          },
        ],
      },
      {
        path: 'ad-manager',
        name: 'ad-manager',
        component: EmptyRouterParent,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: 'home',
            name: 'ad-manager-home',
            component: AdManager,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: ':platform/campaign/:campaignId',
            name: 'campaign-builder',
            beforeEnter: requireAuthAndLocation,
            component: AdManagerCampaignBuilder,
            meta: {
              hideTopBar: true,
              hideSideBar: true,
            },
          },
          {
            path: 'campaign/:platform/:campaignId/statistics',
            name: 'campaign-statistics',
            beforeEnter: requireAuthAndLocation,
            component: AdManagerCampaignStatistics,
            meta: {
              hideTopBar: false,
            },
          },
          {
            path: 'settings',
            name: 'ad-manager-settings',
            beforeEnter: requireAuthAndLocation,
            component: AdManagerSettings,
          },
        ],
      },
      {
        path: 'affiliate-manager',
        component: EmptyRouterParent,
        beforeEnter: requireAuthAndLocation,
        children: [
          {
            path: '',
            name: 'affiliate-manager-onboarding-page-v2',
            component: AffiliateManagerDashboard,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'campaigns',
            name: 'affiliate-manager-campaign-page-v2',
            component: AffiliateManagerDashboard,
            beforeEnter: requireAuthAndLocation,
          },

          {
            path: 'dashboard',
            name: 'affiliate-manager-dashboard-page-v2',
            component: AffiliateManagerDashboard,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'campaigns/create',
            name: 'campaign-create-page-v2',
            component: AffiliateManagerDashboard,
            beforeEnter: requireAuthAndLocation,
            meta: {
              hideTopBar: true,
            },
          },
          {
            path: 'campaigns/:id',
            name: 'campaign-edit-page-v2',
            component: AffiliateManagerDashboard,
            beforeEnter: requireAuthAndLocation,
            meta: {
              hideTopBar: true,
            },
          },
          {
            path: 'campaigns/:id/integration',
            name: 'campaign-integration-page-v2',
            component: AffiliateManagerDashboard,
            beforeEnter: requireAuthAndLocation,
            meta: {
              hideTopBar: true,
            },
          },
          {
            path: 'affiliates',
            name: 'affiliate-manager-affiliates-v2',
            component: AffiliateManagerDashboard,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'affiliates/:id',
            name: 'affiliate-manager-affiliates-details-v2',
            component: AffiliateManagerDashboard,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'payouts',
            name: 'affiliate-manager-payouts-v2',
            component: AffiliateManagerDashboard,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'media',
            name: 'affiliate-manager-media-v2',
            component: AffiliateManagerDashboard,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'settings',
            name: 'affiliate-manager-settings-v2',
            component: AffiliateManagerDashboard,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'media/folder/:folderId',
            name: 'affiliate-manager-media-folder-v2',
            component: AffiliateManagerDashboard,
            beforeEnter: requireAuthAndLocation,
          },
          {
            path: 'importer',
            name: 'affiliate-manager-importer-v2',
            component: AffiliateManagerDashboard,
            beforeEnter: requireAuthAndLocation,
            meta: {
              hideTopBar: false,
            },
          },
        ],
      },
    ],
  },
]
